import { getServices } from "../../platform.js";
import { partitionAndDelete } from "./helpers.js";
import type { SeriesGet, SeriesSet } from "./types.js";

/**
 * Update a recurrence rule's `until` (series end date). Pass null to clear.
 * If shrinking past existing single overrides, those overrides are
 * hard-deleted — they can never match an occurrence again.
 */
export async function editSeriesUntil(
  set: SeriesSet,
  get: SeriesGet,
  ruleId: string,
  untilIso: string | null,
): Promise<void> {
  const { recurrence } = getServices();
  const rule = get().rules[ruleId] ?? await recurrence.findById(ruleId);
  if (!rule) return;

  const now = new Date().toISOString();
  const next = { ...rule, until: untilIso, updated_at: now };
  await recurrence.update(next);

  const overrides = get().overrides[ruleId] ?? [];
  let remaining = overrides;
  if (untilIso) {
    const result = await partitionAndDelete(
      overrides,
      (o) => o.range === "single" && o.recurrence_id_ref >= untilIso,
    );
    remaining = result.remaining;
  }

  set({
    rules: { ...get().rules, [ruleId]: next },
    overrides: { ...get().overrides, [ruleId]: remaining },
  });
}
